import UserContext from '../context/context';
import { render, useContext } from '@wordpress/element';


const Against = () => {

    const context = useContext(UserContext);
    const { againstOpinion, getNextAgainstOpinion } = context;

    return (
        <div class="graphic border">
            <div class="left" style={{marginBottom:'247px'}}>
                <h2>
                    Of the 2% who changed their mind and are now against gay
                    marriage, respondents said...
                </h2>
            </div>
            <div class="right">
                <div id="blockquote2">
                    <div class="refresh" onClick={getNextAgainstOpinion}>Next Quote</div>
                    <p class="quote">
                      {againstOpinion.opinion}
                    </p>
                    <p class="attribution">
                      - {againstOpinion.gender}, {againstOpinion.age} years old
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Against;
